import { useState, useEffect } from 'react'

const convertString = (string) => {
  if(string === undefined) {
    return
  }
  const words = string.split('_');
  const capitalizedWords = words.map((word) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
  const convertedString = capitalizedWords.join(' ');
  return convertedString;
};

export const useIntersection = (element, rootMargin) => {
    const [isVisible, setState] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setState(entry.isIntersecting);
            }, { rootMargin }
        );

        element.current && observer.observe(element.current);

        return () => observer.unobserve(element.current);
    }, []);

    return isVisible;
};

export const dataTrack = (eventName, dataObject, type, otAccepted) => {
	window.dataLayer = window.dataLayer || []
	window.dataLayer.push({
		'event': eventName,
			...dataObject
	})
}

export const isStringInt = (str) => {
  return /^\d+$/.test(str) && Number.isInteger(parseInt(str, 10));
}
export const getFullURL=(url)=>{
    const isFullURL = url?.startsWith("http://") || url?.startsWith("https://");
    if(isFullURL){
      return url;
    }
    const baseUrl=window?.location?.origin;
    const formattedPath = url?.startsWith("/") ? url : `/${url}`;
    return baseUrl+formattedPath;
}
export const isElementInViewport=(el, threshold = 0.5)=>{
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;
  const visiblePx = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
  const ratio = visiblePx / rect.height;
  return ratio >= threshold;
}